import React from 'react';
import { BookOpen, Target, Users, Trophy } from 'lucide-react';

const categories = [
  {
    title: "Traditional Pubs",
    examples: ["The Royal Oak", "Crown & Anchor", "The Golden Lion"],
    description: "Classic pub names that evoke tradition and history."
  },
  {
    title: "Cocktail Lounges",
    examples: ["Velvet Room", "The Crystal Bar", "Azure Lounge"],
    description: "Sophisticated names for upscale cocktail establishments."
  },
  {
    title: "Sports Bars",
    examples: ["Champions Bar & Grill", "The Dugout", "Overtime Sports Bar"],
    description: "Names that appeal to sports enthusiasts and casual fans."
  }
];

const tips = [
  {
    icon: BookOpen,
    title: "Research Your Area",
    content: "Look at local history and culture for inspiration."
  },
  {
    icon: Target,
    title: "Consider Your Audience",
    content: "Choose a name that appeals to your target customers."
  },
  {
    icon: Users,
    title: "Brand Identity",
    content: "Reflect your bar's atmosphere and concept."
  },
  {
    icon: Trophy,
    title: "Memorability",
    content: "Pick a name that's easy to remember and share."
  }
];

export default function BarGuide() {
  return (
    <section className="py-20 bg-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Complete Guide to Bar Names
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {categories.map((category, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{category.title}</h3>
              <ul className="space-y-2 mb-4">
                {category.examples.map((example, i) => (
                  <li key={i} className="text-amber-600">{example}</li>
                ))}
              </ul>
              <p className="text-gray-600">{category.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-lg shadow-md">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Tips for Choosing Your Bar Name
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {tips.map((tip, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber-100 mb-4">
                  <tip.icon className="w-6 h-6 text-amber-600" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{tip.title}</h4>
                <p className="text-gray-600">{tip.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}